import { WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";

const bestQualityWinter23 = {
  name: "Best quality winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_BestUsability_Total.png"
};
const leaderMidMarketWinter23 = {
  name: "Leader mid-market winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_Leader_Mid-Market_Leader.png"
};
const leaderSmallBusinessWinter23 = {
  name: "Leader small business winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_Leader_Small-Business_Leader.png"
};
const leaderEnterpriseWinter23 = {
  name: "Leader enterprise winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_Leader_Enterprise_Leader.png"
};
const usersLoveUs = {
  name: "Users love us",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/users-love-us_1_1.png"
};
const leaderOfWinter23 = {
  name: "Leader winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_Leader_Leader.png"
};
const bestRelationshipWinter23 = {
  name: "Best relationship winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_BestRelationship_Total.png"
};
const momentumLeaderWinter23 = {
  name: "Momentum leader winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_MomentumLeader_Leader.png"
};
const highestUserAdoptionEnterpriseWinter23 = {
  name: "Highest user adoption enterprise winter 2023",
  url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/WorkManagement_HighestUserAdoption_Enterprise_Adoption.png"
};

export default {
  [WORK_MANAGEMENT_PRODUCT_ID]: [
    bestQualityWinter23,
    leaderMidMarketWinter23,
    leaderSmallBusinessWinter23,
    leaderEnterpriseWinter23,
    usersLoveUs,
    leaderOfWinter23,
    bestRelationshipWinter23,
    momentumLeaderWinter23,
    highestUserAdoptionEnterpriseWinter23
  ]
};
